import {Box, Container, Typography, styled, Checkbox} from '@mui/material';

const StyledBox = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 16px;
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	padding: 16px;
	border-radius: 8px;
`;

const LinkText = styled(Typography)`
	text-decoration: underline;
	color: ${({theme}) => theme.colors.brand.primary};
`;

const StyledContainer = styled(Container)`
	margin-top: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-top: 24px;
		padding-inline: 32px;
	}
`;

const StyledFooterContainer = styled(Box)`
	margin-top: auto;
	padding-top: 40px;
	margin-bottom: 132px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-bottom: 0px;
	}
`;

const StyledCheckbox = styled(Checkbox)<{errorToSendState?: boolean}>`
	padding: ${({theme}) => theme.spacing(1)};
	bottom: ${({errorToSendState}) => (errorToSendState ? '16px' : '0')};
	color: ${({theme, errorToSendState}) =>
		errorToSendState ? theme.palette.error.main : theme.palette.text.primary};
`;

export {StyledBox, StyledCheckbox, LinkText, StyledContainer, StyledFooterContainer};
